// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2ggfx","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__H-PFs"};